import React from 'react';
import Icon from '../common/Icon';
import { handleFieldsetEdit } from './constants/handleFieldset';
import { sortable } from '../../helpers/sorters';

const FieldsetListItem = ({
  fieldset,
  hasSubmissions,
  setFieldsets,
  handleDestroy,
  handleCopy,
}) => {
  const { name, comment, title_hidden, id } = fieldset;

  async function handleUpdate(e, property, value) {
    e.preventDefault();
    let fieldset = {};
    fieldset[property] = value;
    let edited = await handleFieldsetEdit(fieldset, id);
    if (edited.ok) {
      setFieldsets((fieldsets) => {
        let updated = fieldsets.find((obj) => obj.id === id);
        updated[property] = value;
        let untouched = fieldsets.filter((obj) => obj.id != id);
        return sortable([...untouched, edited.data]);
      });
    }
  }

  return (
    <>
      <div className='cargo'>
        <div className='name'>{name}</div>
        <div className='meta'>{comment || 'No comment provided.'}</div>
      </div>

      <div className='controls'>
        <Icon
          className='duplicate'
          onClick={(e) => handleCopy(e, id)}
          icon='copy'
          faPrefix={'regular'}
        />
        <Icon
          className='toggle-switch title'
          title={`${title_hidden ? 'show' : 'hide'} fieldset title`}
          onClick={(e) => {
            handleUpdate(e, 'title_hidden', !title_hidden);
          }}
          icon={`${title_hidden ? 'eye-slash' : 'eye'}`}
          faPrefix={'regular'}
        />
        <Icon
          className={'toggle-switch public' + (fieldset.public ? ' on' : '')}
          title={`make ${fieldset.public ? 'private' : 'public'}`}
          onClick={(e) => {
            handleUpdate(e, 'public', !fieldset.public);
          }}
          icon={`${fieldset.public ? 'unlock-alt' : 'lock'}`}
        />
        <Icon
          url={`/manage/fieldsets/${id}`}
          className='edit'
          title='Edit Fieldset'
          icon='pencil'
          isLink
        />

        {!hasSubmissions && (
          <Icon
            className='destroy'
            onClick={(e) => handleDestroy(e, fieldset)}
            icon='trash'
          />
        )}
      </div>
    </>
  );
};

export default FieldsetListItem;
